/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_appsync_graphqlEndpoint": "https://wnwyoli4yvbwbhbt6rfpfc7ruq.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-s33hmmrvmbcrdftfrfpxo4saiu",
    "aws_cognito_identity_pool_id": "ap-south-1:36f2a947-11ca-4870-9186-e1b5706e5649",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_2Tq39XTM6",
    "aws_user_pools_web_client_id": "6oejjt57lh2cs228n9e8klc1hg",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "amplify-ishs-dev-173540-deployment",
    "aws_user_files_s3_bucket_region": "ap-south-1"
};


export default awsmobile;
